<template>
  <div
      class="HEADER-CONTAINER"
      :class="{
        'x-header-light': light,
        ABSOLUTE: transparent,
        'HEADER-PRO': isPro,
  }">

    <header v-if="isPro">
      <div class="w-100">
        <slot/>
      </div>
    </header>

    <header v-else :class="background" class="HEADER">
      <div class="container p-x-1:mo">
        <div class="d-flex">

          <router-link :to="{ name: homepage }" class="m-y-1">
            <header-logo :dark="light"/>
          </router-link>

          <div class="w-100">
            <slot/>
          </div>

        </div>
      </div>
    </header>

    <div class="container">
      <div class="pos-relative">
        <portal-target name="HEADER_MENU" slim/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Storage from '@homeservices/tool-kit/storage/local-storage';
import HeaderLogo from '@/layouts/components/HeaderLogo';

const USER_TYPE = 'USER_TYPE_VALUE';
export default {
  name: 'app-header-base',
  components: {
    HeaderLogo,
  },
  props: {
    transparent: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      homepage: 'homepage',
    };
  },
  computed: {
    ...mapGetters('user', [
      'isPro',
    ]),
    background () {
      return {
        TRANSPARENT: this.transparent,
        'bg-white': this.light,
        'bg-black': !this.light && !this.transparent,
      };
    },
  },
  updated () {
    const userIsLogged = this.$store.getters['user/isLoggedIn'];
    let homepage = Storage.get(USER_TYPE) === 'PRO_USER' && !userIsLogged ? 'pro-homepage' : 'homepage';
    homepage = this.$store.getters['user/isPro'] ? 'dashboard' : homepage;
    this.homepage = homepage;
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";
.HEADER {
  transition: all 200ms ease;
  z-index: 5;
}
.HEADER-CONTAINER {
  width: 100%;
  position: fixed;
  z-index: 200; // needs to cover mostly everything
  box-shadow: 0 8px 6px -6px rgba(black, 0.30);
  &.ABSOLUTE {
    position: absolute;
  }
  &.HEADER-PRO{
    position: relative;
  }
}
.HEADER {
  &.TRANSPARENT {
    background-color: rgba(0, 0, 0, 0.5);
  }
}
</style>
